<template>
  <v-card
    v-if="!pageloading"
    :class="`services-card${light ? '-light' : ''} ${deleted ? 'deleted' : ''}`"
    outlined
  >
    <v-card-text class="pb-0">
      <!-- header  -->
      <v-row style="align-items: center">
        <v-col class="py-0" cols="6" md="6">
          <h3>{{ getServiceTitle }}<small>{{getServiceCodes}}</small></h3>
        </v-col>
        <v-col class="py-0" cols="5" md="5" v-if="getInstitutionTitle">
          <h3>{{ getInstitutionTitle }}</h3>
        </v-col>
        <v-spacer></v-spacer>

        <v-tooltip v-if="showAddService" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click.native="addService()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <div class="tooltip-text">{{ $t('Pridėti') }}</div>
        </v-tooltip>
         <v-tooltip v-if="!deleted" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon @click.native="removeService()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <div class="tooltip-text">{{ $t('Šalinti') }}</div>
        </v-tooltip>
      </v-row>
      <v-row>
        <v-col class="pb-0" cols="12" md="12">
          <el-textarea
            v-if="showTextarea"
            label="Paslaugos aprašymas"
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Paslaugos aprašymas"
            :tooltipIndexKey= generateKey
            class="pb-2"
            :required="false"
            :disabled="!item.default_description_editable || subMandate"
            v-model="item.description"
            :validateKey="generateKey"
            :key="generateKey"
            :maxlength="2000"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else type="list-item-three-line"></v-skeleton-loader>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'ServicesCard',
  props: {
    item: [Object, Boolean, String, Number],
    light: { type: Boolean, default: false },
    index: [String, Number],
    deleted: { type: Boolean, default: false },
    subMandate: { type: Boolean, default: false },
    providerType: String,
  },
  data() {
    return {
      pageloading: false,
    }
  },
  created() {},

  computed: {
    showAddService(){
      return this.deleted && !this.hasInactivePerson
    },
    hasInactivePerson(){
      return this.item.service_has_ended
    },
    showTextarea(){
      if((!this.item.default_description_editable || this.subMandate) && !this.item.description){
        return false
      }
      return true
    },
    generateKey(){
      let key = ``
      this.index && (key += `${this.index}_`)
      this.item.action_id && (key += `${this.item.action_id}_`)
      this.item.unique_id && (key += `${this.item.unique_id}_`)
      key += `_description`
      return key
    },
    getServiceCodes(){
      let code = ``
      this.item.code && (code += ` (${this.item.code || ''})`)
      this.item.pasis_code && (code += ` (${this.item.pasis_code || ''})`)
      return code
    },
    getServiceTitle() {
      let text = ``
      if(this.hasInactivePerson){
        text += `(` + this.$t('Pasibaigusi') + `) `
      }
      text += this.$i18n.locale === 'lt'
        ? (this.item.title_lt || '')
        : (this.item.title_en || '')

      return text
    },
    getInstitutionTitle() {
      let title = ''
      let provider_type = this.providerType
      if (provider_type === 'amn') {
        title = this.item?.institution?.fullname || ''
      } else {
        title = this.$t(Enums.providerType[provider_type])
      }
      return title
    },
    elValue: {
      get() {
        return this.item
      },
      set(elValue) {
        this.$emit('item', elValue)
      },
    },
  },
  methods: {

    addService() {
      let item = this.item
      item.index = this.index
      this.$emit('addServiceItem', item)
    },
    removeService() {
      let item = this.item
      item.index = this.index
      this.$emit('removeServiceItem', item)
    },
  },
}
</script>

<style lang="scss" scoped></style>
